<template>
  <div class="swiper">
    <van-swipe
      class="my-swipe"
      :autoplay="5000"
      :show-indicators="false"
      :loop="false"
      :lazy-render="true">
      <template
        v-for="(image, imageIndex) in imagesGroupByCategoryFlatted"
        :key="imageIndex">
        <template v-if="navigatable">
          <van-swipe-item>
            <router-link
              :to="{
                name: 'carPhotos',
                params: {
                  id: car.etId
                }
              }"
              class="gallery-image-wrapper">
              <img
                :class="'gallery-image-el'"
                :src="`${image}!/fw/960/rotate/auto/format/webp`"
                loading="lazy">
            </router-link>
          </van-swipe-item>
        </template>
        <template v-else>
          <div class="gallery-image-wrapper">
            <img
              class="swiper-lazy gallery-image-el"
              :src="globalImagePlaceholder"
              :data-src="globalImagePlaceholder">
          </div>
        </template>
      </template>

      <template #indicator="{ active, total }">
        <div class="active-index-wrapper">{{ active + 1 }}/{{ total }}</div>
      </template>
    </van-swipe>
    <template v-if="car.car.is_forestall">
      <div class="early-access-indicator">整备路试中</div>
    </template>
  </div>
</template>

<script>
import {Swipe, SwipeItem} from 'vant'
import {ref} from 'vue'
import {mapGetters} from 'vuex'
import {globalImagePlaceholder} from '@constants'

export default {
  name: 'GallerySwiper',

  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
  },

  setup () {
    const activeOfSwiper = ref(1)

    const slideDidChange = (e) => {
      activeOfSwiper.value = e.activeIndex + 1
    }

    return {
      slideDidChange,
      activeOfSwiper,
    }
  },

  data () {
    return {
      globalImagePlaceholder,
    }
  },

  computed: {
    ...mapGetters('Car', [
      'carByCarId',
      'imagesGroupByCategoryFlattedbyCarId',
    ]),

    carId () {
      return this.$route.params.id
    },

    car () {
      return this.carByCarId(this.carId)
    },

    // imagesGroupByCategoryFlatted
    imagesGroupByCategoryFlatted () {
      return this.imagesGroupByCategoryFlattedbyCarId(this.carId)
    },

    // navigatable
    navigatable () {
      return this.imagesGroupByCategoryFlatted.length > 0
    },

    zcarPhotoLink () {
      return '/car/' + this.car.id + '/photos'
    },
  },

  updated () {
    window.dispatchEvent(new Event('resize'))
  },
}
</script>

<style lang="scss" scoped>
.swiper {
  position: relative;
  overflow: hidden;
}

.swiper-el {
  position: relative;
  z-index: 0;
}

.gallery-swiper-pagination {
  padding-right: 10px;
  text-align: right;
  box-sizing: border-box;
}

.gallery-image-wrapper {
  width: 100%;
  box-sizing: border-box;
  height: auto;
  position: relative;
  display: block;

  &:hover {
    cursor: pointer;
    filter: brightness(.95);
  }
}

.gallery-image-wrapper::before {
  content: '';
  display: block;
  padding-bottom: calc(100% / 3 * 2);
  box-sizing: border-box;
  width: 100%;
}

.gallery-image-el {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.active-index-wrapper {
  position: absolute;
  right: 15px;
  bottom: 15px;
  color: #ffffff;;
}

.early-access-indicator {
  color: white;
  background: rgba(216, 0, 20, .5);
  font-size: .9rem;
  text-align: center;
  padding: 2px 0;
  z-index: 100;
  width: 100%;
  letter-spacing: 2px;
  position: absolute;
  left: 0;
  bottom: 0;
  user-select: none;
}
</style>
